import { useTruckerProps } from 'hooks/useTruckerProps';
import { useNavigate } from 'react-router-dom';

const useTruckerNavigation = () => {
  const { eventsSource } = useTruckerProps();
  const navigate = useNavigate();

  const handleNavigation = (path: string, options?: { newTab?: boolean }) => {
    if (eventsSource === 'ChatFretebras') {
      const trimmedPath = path.startsWith('/') ? path.slice(1) : path;
      const targetUrl = `${process.env.NCA_MF_APP_HOST}${trimmedPath}`;
      window.open(targetUrl, options?.newTab ? '_blank' : '_self');
    } else {
      navigate(path);
    }
  };

  return { handleNavigation };
};

export { useTruckerNavigation };
